import { Fragment, useEffect, useState, useContext } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { Bars3Icon, FlagIcon, XMarkIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline'
import Cookies from 'js-cookie';
import { AuthContext } from './AuthContext';
import { useLocation } from 'react-router-dom';

const loggedInUser = [
  { name: 'Dodaj obvestilo', href: '/dodaj-obvestilo' },
  { name: 'Meritve dozorevanja grozdja', href: '/dozorevanje-grozdja/meritve' },
  { name: 'Odjava', href: '#' },
]

const notLoggedInUser = [
  { name: 'Login', href: '/login' }
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Navigation() {

  const { isLoggedIn } = useContext(AuthContext);
  const [userNavigation, setUserNavigation] = useState(notLoggedInUser);

  const location = useLocation();

  const navigation = [
    { name: 'Agrometeorološki podatki', href: '/', current: location.pathname === '/' },
    { name: 'Prostorski in okoljski podatki', href: '/prostorski-okoljski-podatki', current: location.pathname.startsWith('/prostorski-okoljski-podatki') },
    { name: 'Dozorevanje grozdja', href: '/dozorevanje-grozdja', current: location.pathname.startsWith('/dozorevanje-grozdja') },
    { name: 'Analize in raziskave', href: '/analize-raziskave', current: location.pathname.startsWith('/analize-raziskave') },
    { name: 'Novice in dogodki', href: '/novice-dogodki', current: location.pathname.startsWith('/novice-dogodki') },
  ]

  useEffect(() => {
    setUserNavigation(isLoggedIn ? loggedInUser : notLoggedInUser);
  }, [isLoggedIn]);

  return (
    <>
      <div className="min-h-full">
        <Disclosure as="nav" className="bg-gray-200 shadow">
          {({ open }) => (
            <>
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 items-center justify-between">
                  <div className="flex items-center">
                    <div className="hidden md:block">
                      <div className="flex items-baseline space-x-4">
                        {navigation.map((item) => (
                          <a
                            key={item.name}
                            href={item.href}
                            className={classNames(
                              item.current
                                ? 'bg-white text-gray-800'
                                : 'text-gray-700 hover:bg-white hover:text-gray-800 hover:border-solid ',
                              'rounded-md px-3 py-2 text-sm font-medium'
                            )}
                            aria-current={item.current ? 'page' : undefined}
                          >
                            {item.name}
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="hidden md:block">
                    <div className="ml-4 flex items-center md:ml-6">

                      {/* Profile dropdown */}
                      <Menu as="div" className="relative ml-3">
                        <div>
                          <Menu.Button className="rounded-full bg-gray-200 p-1 text-gray-800 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                            <span className="sr-only">Open user menu</span>
                            <ArrowRightOnRectangleIcon className="h-6 w-6" aria-hidden="true" />
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">


                            {userNavigation.map((item) => (
                              <Menu.Item key={item.name}>
                                {({ active }) => (
                                  <a
                                    href={item.href}
                                    className={classNames(
                                      active ? 'bg-gray-100' : '',
                                      'block px-4 py-2 text-sm text-gray-700'
                                    )}
                                  >
                                    {item.name}
                                  </a>
                                )}
                              </Menu.Item>
                            ))}
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  </div>
                  <div className="-mr-2 flex md:hidden">
                    {/* Mobile menu button */}
                    <Disclosure.Button className="inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                      ) : (
                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                      )}
                    </Disclosure.Button>
                  </div>
                </div>
              </div>

              <Disclosure.Panel className="md:hidden">
                <div className="space-y-1 px-2 pb-3 pt-2 sm:px-3">
                  {navigation.map((item) => (
                    <Disclosure.Button
                      key={item.name}
                      as="a"
                      href={item.href}
                      className={classNames(
                        item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                        'block rounded-md px-3 py-2 text-base font-medium'
                      )}
                      aria-current={item.current ? 'page' : undefined}
                    >
                      {item.name}
                    </Disclosure.Button>
                  ))}
                </div>
                <div className="border-t border-gray-700 pb-3 pt-4">
                  <div className="flex items-center px-5">
                    <div className="flex-shrink-0">
                      <FlagIcon className="h-6 w-6" aria-hidden="true" />
                    </div>

                  </div>
                  <div className="mt-3 space-y-1 px-2">
                    {userNavigation.map((item) => (
                      <Disclosure.Button
                        key={item.name}
                        as="a"
                        href={item.href}
                        className="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white"
                      >
                        {item.name}
                      </Disclosure.Button>
                    ))}
                  </div>
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>


      </div>
    </>
  )
}
